module.exports = __webpack_public_path__ + "static/media/exukonline_tyres.ae79ea2d.jpg";